import type { CSSProperties } from "react"
import type { ColumnDefinition, Area } from "../types"
import { getLayoutVariables } from "./helpers"

type ColumnManagerProps = {
  columns: ColumnDefinition[]
  onUpdate: () => void
}
export class ColumnManager {
  props: ColumnManagerProps
  columns: ColumnDefinition[] = []
  hasFixedColumns: boolean = false
  fixedColumns: ColumnDefinition[] = []
  mainColumns: ColumnDefinition[] = []
  layoutVariables: CSSProperties = {}
  columnsById: Record<string, ColumnDefinition> = {}
  constructor(props: ColumnManagerProps) {
    this.props = props
    this.onColumnsChange(props.columns)
  }

  onReceiveColumns = (nextColumns: ColumnDefinition[]) => {
    if (nextColumns !== this.columns) {
      this.onColumnsChange(nextColumns)
      this.update()
    }
  }

  onColumnsChange = (columns: ColumnDefinition[]) => {
    this.columns = columns
    this.columnsById = indexById(columns)
    this.mainColumns = columns.filter((c) => !c.fixed)
    let fixedColumns = columns.filter((c) => !!c.fixed)
    this.fixedColumns = fixedColumns
    this.hasFixedColumns = fixedColumns.length > 0
    this.calculateVars()
  }

  private readonly calculateVars = () => {
    this.layoutVariables = getLayoutVariables(
      this.fixedColumns,
      this.mainColumns,
    )
  }

  private update = () => {
    this.props.onUpdate()
  }

  getColumnIndexById = (columnId: string): number => {
    return this.columns.findIndex((col) => col.id === columnId)
  }

  getColumnById = (columnId: string): ColumnDefinition | undefined => {
    return this.columnsById[columnId]
  }

  onColumnResize = (width: number, column: ColumnDefinition): void => {
    const columnIndex = this.getColumnIndexById(column.id)
    this.columns[columnIndex].width = width
    this.calculateVars()
    this.update()
  }

  getColumnsByArea = (area: Area): ColumnDefinition[] => {
    return area === "fixed" ? this.fixedColumns : this.mainColumns
  }
}

function indexById<T extends { id: string }>(list: T[]): Record<string, T> {
  const o: Record<string, T> = {}
  list.forEach((it) => {
    o[it.id] = it
  })
  return o
}
